import React from 'react';
import TableHeader from './TableHeader';
import TableBodyData from './TableBody';
import { Table } from '@mui/material';

export default function TableData({ filteredRows, loadingFilteredData, ordersHistoryDate }) {
  return (
    <Table
      style={{
        paddingLeft: 20,
        paddingRight: 20,
        width: '90%',
        margin: 'auto',
      }}
    >
      <TableHeader />
      
      <TableBodyData filteredRows={filteredRows} loadingFilteredData={loadingFilteredData} ordersHistoryDate={ordersHistoryDate}/>
    </Table>
  );
}
